import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ReAdPQC25',
  templateUrl: './ReAdPQC25.component.html',
  styleUrls: ['./ReAdPQC25.component.css']
})
export class ReAdPQC25Component {
}
